import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const Container = styled.div`
    width: 100vw;
    height: 35px;
    display: flex;
    align-items: center;
    position: relative;
    ${({ theme }) => css`
        background-color: ${theme.color.black};
        color: ${theme.color.white};
        @media (max-width: ${theme.breakpoint.tablet}px) {
            height: 48px;
        }
    `};
`;

export const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

export const Left = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    padding-left: 12px;
    height: 100%;
`;

export const Right = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const Icon = styled.div`
    width: 26px;
    height: 26px;
    &.pad {
        padding-left: 10px;
    }
`;

export const Logo = styled.img`
    height: 10px;
    margin-left: 8px;
`;

export const ClockContainer = styled.div`
    padding: 0 6px;
`;
